import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Form } from "react-bootstrap";
import cx from "classnames";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SuccessToast } from "components/Toast";

import { changePassword } from "actions/users";

import _ from "lodash";

import styles from "./password.module.scss";

export default function Password() {
  const dispatch = useDispatch();

  const [state, setState] = useState({
    oldPassword: null,
    newPassword: null,
    confirmPassword: null,
    visible: false,
    error: {},
  });

  var passwordErrors = useSelector((state) =>
    _.get(state, "users.changePassword.error.errors")
  );
  var changing = useSelector((state) =>
    _.get(state, "users.changePassword.changing", false)
  );

  useEffect(() => {
    if (passwordErrors != null) {
      var error = {};
      passwordErrors.forEach((passwordError) => {
        error[passwordError.field] = passwordError.message;
      });

      setState(state => {
        return {
          ...state,
          error: error
        }
      })
    }
  }, [passwordErrors]);

  const handlePasswordSave = () => {
    dispatch(
      changePassword(state.oldPassword, state.newPassword, state.confirmPassword,
        () => {
          toast(
            <SuccessToast
              heading={`Success`}
              description={"Password Updated Successfully"}
            />,
            {
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 3000,
            }
          );

          setState(state => {
            return {
              ...state,
              oldPassword: '',
              newPassword: '',
              confirmPassword: '',
              error: {}
            }
          })
        }
      )
    );
  };

  const handlePasswordCancel = () => {
    setState(state => {
      return {
        ...state,
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
        error: {}
      }
    })
  };

  const handleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className={styles.passwordWrapper}>
      <span className={styles.heading}>Reset Password</span>
      <Form className={styles.detailForm}>
        <Form.Group className={styles.formCluster}>
          <Form.Group className={styles.formGroup}>
            <Form.Label className={styles.userFormLabel}>
              Old Password
            </Form.Label>
            <Form.Control
              className={styles.userFormInput}
              type="password"
              name="oldPassword"
              value={state.oldPassword}
              isInvalid={state.error}
              onChange={handleChange}
            />
            <Form.Control.Feedback type="invalid" className={styles.error}>
              {state.error.oldPassword}
            </Form.Control.Feedback>
          </Form.Group>
        </Form.Group>
        <Form.Group className={styles.formCluster}>
          <Form.Group className={cx(styles.formGroup,styles.secondaryFields)}>
            <Form.Label className={styles.userFormLabel}>
              New Password
            </Form.Label>
            <Form.Control
              className={styles.userFormInput}
              type="password"
              name="newPassword"
              value={state.newPassword}
              isInvalid
              onChange={handleChange}
            />
            <Form.Control.Feedback type="invalid" className={styles.error}>
              {state.error.newPassword}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className={styles.formGroup}>
            <Form.Label className={styles.userFormLabel}>
              Confirm Password
            </Form.Label>
            <Form.Control
              className={styles.userFormInput}
              type="password"
              name="confirmPassword"
              value={state.confirmPassword}
              onChange={handleChange}
              isInvalid
            />
            <Form.Control.Feedback type="invalid" className={styles.error}>
              {state.error.oldPassword1}
            </Form.Control.Feedback>
          </Form.Group>
        </Form.Group>
        <div className={styles.formButtons}>
          <Button
            className={styles.actionButton}
            variant="primary"
            onClick={handlePasswordSave}
            disabled={changing}
          >
            {changing ? "Saving..." : "Save Changes"}
          </Button>

          <Button onClick={handlePasswordCancel} variant="secondary" className={styles.cancel}>
            Cancel
          </Button>
        </div>
      </Form>
    </div>
  );
}
